import React from 'react';
import PropTypes from "prop-types";

import {COUNTRIES} from "../../constants/countries";

function UserDropdownItem({item}) {
    let school = [];
    if (item.school) {
        school.push(item.school.name);
        if (item.school.location) {
            school.push(item.school.location);
        }
        if (item.school.city) {
            school.push(item.school.city);
        }
        if (item.school.state) {
            school.push(item.school.state);
        }
        if (item.school.district && item.school.district.name) {
            school.push(item.school.district.name);
        }
        if (item.school.country && COUNTRIES.hasOwnProperty(item.school.country)) {
            school.push(item.school.country);
        }
        if (item.school.zip) {
            school.push(item.school.zip);
        }
    }

    return (
        <div>
            <div className="autocomplete-dropdown-menu-item-title">{item.fname + ' ' + (item.lname ? item.lname : '')}</div>
            <div className="autocomplete-dropdown-menu-item-second">{item.email}</div>
            <div className="autocomplete-dropdown-menu-item-second">{item.persona}</div>
            <div className="autocomplete-dropdown-menu-item-second">{school.join(', ')}</div>
        </div>
    );
}

UserDropdownItem.propTypes = {
    item: PropTypes.shape({
        id: PropTypes.number.isRequired,
        persona: PropTypes.string.isRequired,
        email: PropTypes.string.isRequired,
        fname: PropTypes.string.isRequired,
        lname: PropTypes.string,
        school: PropTypes.shape({
            name: PropTypes.string.isRequired,
            location: PropTypes.string,
            city: PropTypes.string,
            state: PropTypes.string,
            country: PropTypes.string,
            zip: PropTypes.string,
            district: PropTypes.shape({
                name: PropTypes.string.isRequired
            }),
        })
    }).isRequired
};

export default UserDropdownItem;
